<template>
  <Page />
</template>

<script>
let isMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);

if (isMobile) {
  import("./assets/css/mobile.scss");
} else {
  import("./assets/css/pc.scss");
}

export default {
  components: {
    Page: () => import("./components/page.vue"),
  },
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}
</style>
